import { Close, SendOutlined, ShareOutlined } from "@mui/icons-material";
import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogContent,
  DialogTitle,
  Hidden,
  IconButton,
  Paper,
  TextField,
  Typography
} from "@mui/material";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useSearchParams } from "react-router-dom";
import { toast } from "../features/snackbar/snackbarSlice";
import { useGetUserInfoQuery, useShareMutation } from "../services/api";

const ReferSomeone = () => {
  const [open, setOpen] = useState(false)
  const [email, setEmail] = useState('')
  const [share, { isLoading }] = useShareMutation()
  const dispatch = useDispatch()
  const [searchParams, setSearchParams] = useSearchParams()
  const {
    data: user,
  } = useGetUserInfoQuery()

  useEffect(() => {
    if (searchParams.has('invite')) {
      console.debug(localStorage.getItem('last_invite'), Date.now() - (24 * 60 * 60 * 1000))
      if (localStorage.getItem('last_invite') && (
        +localStorage.getItem('last_invite')! > (
          Date.now() - (24 * 60 * 60 * 1000)
        )
      )) {
        searchParams.delete('invite')
        setSearchParams(searchParams)
      }
      else setOpen(true)
    }
  }, [searchParams, setSearchParams])

  const handleClose = () => {
    searchParams.delete('invite')
    setSearchParams(searchParams)
    setOpen(false)
  }

  const referType = user?.memberType === 'responder'
    ? 'First Responder'
    : 'Friend';
  return (
    <>
      <Paper
        sx={{
          marginLeft: 2,
          padding: 2,
          marginRight: {
            xs: 2,
            md: 0,
          },
          md: {
            width: '100%',
          },
          textAlign: 'center',
        }}
      >
        <Typography
          style={{
            fontWeight: 300,
          }}
        >Anonymously Refer a <Hidden smDown><br /></Hidden>{referType}</Typography>
        <Button
          endIcon={<ShareOutlined />}
          fullWidth
          onClick={() => setOpen(true)}
        >Share</Button>
      </Paper>
      <Dialog
        fullWidth
        maxWidth='sm'
        onClose={handleClose}
        open={open}
        PaperProps={{
          style: {
            backgroundColor: '#a0b1af'
          }
        }}
      >
        <DialogTitle>
          <Typography
            fontSize={22}
          >Refer A {referType}</Typography>
          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <Close />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <Paper
            elevation={0}
            style={{
              alignItems: 'flex-end',
              display: 'flex',
              flexDirection: 'column',
              padding: 26
            }}
          >
            <Box
              component='form'
              display='flex'
              flexDirection='column'
              justifyContent='center'
              onSubmit={(e: any) => {
                e.preventDefault()
                share({
                  email,
                })
                  .unwrap()
                  .then(() => {
                    localStorage.setItem('last_invite', String(Date.now()))
                    dispatch(
                      toast({
                        message: 'Thank you for sharing!',
                        severity: 'success',
                      })
                    );
                    setEmail('')
                    handleClose()
                  })
              }}
              style={{
                width: '100%'
              }}
            >
              <TextField
                autoFocus
                fullWidth
                label="Email"
                onChange={e => setEmail(e.target.value)}
                required
                value={email}
              />
              <Button
                disabled={isLoading}
                endIcon={isLoading
                  ? null
                  : <SendOutlined />
                }
                type='submit'
                variant='contained'
              >{isLoading
                ? <CircularProgress
                  size={25} />
                : 'Send'}</Button>
            </Box>
          </Paper>
        </DialogContent>
      </Dialog>
    </>
  );
}

export default ReferSomeone;